import { Textual }			from "@v3/data/textual";
import { NonEmptyString }	from "@v3/data/primitive";

export type TimezoneName	= Textual.Value<typeof Base>;

const Base	= NonEmptyString.rebrand("TimezoneName");

namespace Extension {
	export const utc	= Base.brand("UTC");
};

export const TimezoneName	= { ...Extension, ...Base };
